// опции
export interface ValidationChangePasswordOptions {
	loginName: string,
	lastName: string,
	firstName: string,
	middleName: string,
	oldPassword: string,
	newPassword: string,
	confirmPassword: string,
	userEditHimself: boolean,
	minPasswordLength: number,
	restrictNumericPasswords: boolean,
	allowNumericPassword?: boolean
}

export class ChangePasswordValidator {
	private options: ValidationChangePasswordOptions;

	constructor(options: ValidationChangePasswordOptions) {
		this.options = options;
	}

	checkOldPasswordEmpty() {
		return this.options.userEditHimself && !this.options.oldPassword;
	}

	checkNewPasswordEmpty() {
		return !this.options.newPassword;
	}

	checkNewPasswordLessLength() {
		return this.options.newPassword.length < this.options.minPasswordLength;
	}

	checkDifferentPassword() {
		return this.options.confirmPassword.length > 0 && this.options.newPassword != this.options.confirmPassword
	}

	checkNewPasswordSimple() {
		let upperPass = this.options.newPassword.toUpperCase();
		let upperLastName = this.options.lastName?.toUpperCase() || "";
		let upperFirstName = this.options.firstName?.toUpperCase() || "";
		let upperLoginName = this.options.loginName?.toUpperCase() || "";
		let firstSymbolFN = upperFirstName.charAt(0);
		let firstSymbolMN = this.options.middleName ? this.options.middleName.toUpperCase().charAt(0) : "";

		return upperPass == upperLoginName || upperPass == upperLastName || upperPass == upperFirstName ||
			upperPass == upperLastName + upperFirstName || upperPass == upperFirstName + upperLastName ||
			upperPass == upperLastName + firstSymbolFN || upperPass == firstSymbolFN + upperLastName ||
			upperPass == upperLastName + firstSymbolFN + firstSymbolMN || upperPass == firstSymbolFN + firstSymbolMN + upperLastName;
	}

	checkNewPasswordNumeric() {
		let upperPass = this.options.newPassword.toUpperCase();
		return !this.options.allowNumericPassword &&
			(this.options.restrictNumericPasswords && !/\D/.test(upperPass));
	}

	checkNewPasswordEqualOld() {
		return this.options.userEditHimself && this.options.newPassword == this.options.oldPassword;
	}

	checkNewPasswordSurroundSpaces() {
		return this.options.newPassword.charAt(0) == ' ' || this.options.newPassword.charAt(this.options.newPassword.length - 1) == ' ';
	}
}